import { render } from "./UploadBlock.vue?vue&type=template&id=016c6462&scoped=true"
import script from "./UploadBlock.vue?vue&type=script&lang=js"
export * from "./UploadBlock.vue?vue&type=script&lang=js"

import "./UploadBlock.vue?vue&type=style&index=0&id=016c6462&scoped=true&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016c6462"]])

export default __exports__